import { brandByCode, brandById, brandColor } from "@/lib/brands";
import { cn } from "@/lib/utils";

/** A university: colored square + short code (CREU, MHU…). Not a status pill on purpose. */
export function BrandMark({ code, id, className, title, dim }: { code?: string; id?: number | null; className?: string; title?: string; dim?: boolean }) {
  const b = code ? brandByCode(code) : brandById(id);
  if (!b) return <span className={cn("text-xs text-[var(--color-muted-foreground)]", className)}>{code ?? "—"}</span>;
  return (
    <span
      className={cn("inline-flex items-center gap-1 text-xs font-semibold tracking-wide", className)}
      // Dimmed (no consent): muted text that still reads at 4.5:1, and only the square faded.
      style={{ color: dim ? "var(--color-muted-foreground)" : brandColor(b.code, "fg") }}
      title={title ?? b.name}
    >
      <span aria-hidden className={cn("inline-block size-2 rounded-[2px]", dim && "opacity-40")} style={{ background: brandColor(b.code, "solid") }} />
      {b.short}
    </span>
  );
}
